import { FC, PropsWithChildren } from 'react';

type Props = {
	className?: string;
};

const SriLankaFlagIcon: FC<PropsWithChildren<Props>> = ({ className }) => {
	return (
		<svg
			width='20'
			height='14'
			viewBox='0 0 20 14'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
			className={`${className}`}>
			<rect
				width='20'
				height='14'
				rx='2'
				fill='white'
			/>
			<mask
				id='mask0_2332_15427'
				style={{ maskType: 'luminance' }}
				maskUnits='userSpaceOnUse'
				x='0'
				y='0'
				width='20'
				height='14'>
				<rect
					width='20'
					height='14'
					rx='2'
					fill='white'
				/>
			</mask>
			<g mask='url(#mask0_2332_15427)'>
				<rect
					width='20'
					height='14'
					fill='#FFBF19'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M7.61914 0.93335H17.7144C18.4508 0.93335 19.0477 1.5303 19.0477 2.26668V11.7334C19.0477 12.4697 18.4508 13.0667 17.7144 13.0667H7.61914V0.93335Z'
					fill='#A52531'
				/>
				<path
					d='M0.953125 2.26668C0.953125 1.5303 1.55008 0.93335 2.28646 0.93335H3.81027V13.0667H2.28646C1.55008 13.0667 0.953125 12.4697 0.953125 11.7334V2.26668Z'
					fill='#03664F'
				/>
				<rect
					x='3.80859'
					y='0.93335'
					width='2.85714'
					height='12.1333'
					rx='0.666667'
					fill='#FF6816'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M9.52465 2.33337C9.52465 2.5911 9.31145 2.80003 9.04846 2.80003C8.78546 2.80003 8.57227 2.5911 8.57227 2.33337V1.8667H9.04846C9.31145 1.8667 9.52465 2.07563 9.52465 2.33337ZM17.1437 2.33337C17.1437 2.5911 17.3569 2.80003 17.6199 2.80003C17.8829 2.80003 18.0961 2.5911 18.0961 2.33337V1.8667H17.6199C17.3569 1.8667 17.1437 2.07563 17.1437 2.33337ZM17.6199 11.2C17.3569 11.2 17.1437 11.409 17.1437 11.6667C17.1437 11.9244 17.3569 12.1334 17.6199 12.1334H18.0961V11.6667C18.0961 11.409 17.8829 11.2 17.6199 11.2ZM9.52465 11.6667C9.52465 11.409 9.31145 11.2 9.04846 11.2C8.78546 11.2 8.57227 11.409 8.57227 11.6667V12.1334H9.04846C9.31145 12.1334 9.52465 11.9244 9.52465 11.6667Z'
					fill='#FFBF18'
				/>
				<path
					fillRule='evenodd'
					clipRule='evenodd'
					d='M11.4293 8.81083C11.4293 8.58396 11.2454 8.40004 11.0185 8.40004C10.9752 8.40004 10.9322 8.39323 10.8913 8.37891C10.6171 8.28292 9.52455 7.87481 9.52455 7.4667C9.52455 7.26303 9.61526 7.05935 9.71749 6.89447C9.86338 6.65921 9.92699 6.36605 9.83092 6.10643C9.67101 5.67432 9.46431 5.02088 9.52455 4.6667C9.54462 4.54868 9.59858 4.43893 9.67123 4.33922C9.95412 3.95097 10.4769 4.27083 10.4769 4.75121V6.11764C10.4769 6.37208 10.6218 6.60434 10.8503 6.7163L11.2298 6.90225C11.3494 6.96086 11.4929 6.93771 11.588 6.84449C11.743 6.69266 11.7011 6.43323 11.5063 6.33778L10.9531 6.0667V5.60004C11.1871 5.60004 11.2604 5.28392 11.0503 5.18098L10.9531 5.13337V4.6667H11.6333C11.8078 4.6667 11.9753 4.5983 12.0999 4.47618L12.1873 4.39056C12.3119 4.26844 12.4794 4.20004 12.6539 4.20004H12.9258C13.1763 4.20004 13.4058 4.34053 13.5196 4.56372L13.6822 4.88243C13.7641 5.04285 13.7775 5.22957 13.7195 5.40008L13.6339 5.65202C13.4868 6.08445 13.8083 6.53337 14.265 6.53337H15.5657C15.6614 6.53337 15.7533 6.49584 15.8217 6.42882C16.002 6.2521 15.9534 5.95015 15.7266 5.83905L15.373 5.66576C15.2847 5.62252 15.1877 5.60004 15.0895 5.60004H14.9437C14.5807 5.60004 14.2865 5.30579 14.2865 4.94283C14.2865 4.76622 14.3575 4.59705 14.4837 4.47344L14.7626 4.20004V4.65718C14.7626 4.92017 14.9758 5.13337 15.2388 5.13337H15.7829C16.0335 5.13337 16.2629 5.27386 16.3768 5.49706L16.6121 5.95839C16.6487 6.03001 16.672 6.10742 16.6791 6.18751C16.7024 6.45063 16.7458 7.08268 16.6674 7.4667C16.6082 7.7569 16.4544 8.02797 16.3375 8.20239C16.2491 8.33435 16.1912 8.48733 16.1912 8.6462V9.90497C16.1912 10.1048 16.0293 10.2667 15.8295 10.2667C15.5593 10.2667 15.3845 9.98125 15.5073 9.74058L15.663 9.43533C15.6957 9.37128 15.6957 9.29546 15.663 9.23141L15.6398 9.18601C15.5386 8.98749 15.2388 9.05953 15.2388 9.28239C15.2388 9.3159 15.2309 9.34893 15.2157 9.37878L14.8807 10.0353C14.8083 10.1773 14.6623 10.2667 14.5029 10.2667C14.186 10.2667 13.981 9.93198 14.125 9.64976L14.2253 9.45313C14.2655 9.37441 14.2865 9.2873 14.2865 9.19892V9.0667C14.2865 8.69851 13.988 8.40004 13.6198 8.40004H13.0484C12.6802 8.40004 12.3817 8.69851 12.3817 9.0667V9.17313C12.3817 9.27846 12.3567 9.38229 12.3089 9.47611L12.0236 10.0353C11.9511 10.1773 11.8051 10.2667 11.6457 10.2667C11.3289 10.2667 11.1239 9.93198 11.2679 9.64976L11.3682 9.45313C11.4084 9.37441 11.4293 9.2873 11.4293 9.19892V8.81083Z'
					fill='#FFBF18'
				/>
			</g>
		</svg>
	);
};

export default SriLankaFlagIcon;
